import * as Sentry from '@sentry/nextjs';
import LogRocket from 'logrocket';

import { IS_DEV } from '@/lib/constants';
import { CurrentUserType } from '@/queries/current-user';

let logRocketIsInitialized = false;

// Initialize LogRocket and set the user
export const handleLogRocket = (user: CurrentUserType | null, routerAsPath: string) => {
    // Do not send dev sessions to logrocket
    if (IS_DEV) return;
    // Do not send admin page sessions to logrocket
    if (routerAsPath.startsWith('/admin/')) return;
    if (!logRocketIsInitialized) {
        logRocketIsInitialized = true;
        LogRocket.init('jovyyb/thematic');
        LogRocket.getSessionURL((sessionURL) => {
            Sentry.withScope((scope) => {
                scope.setExtra('sessionURL', sessionURL);
            });
        });
    }
    if (!user) {
        return;
    }
    // I'm purposefully not de-identifying the user on logout/changing account.
    LogRocket.identify(user.id, { email: user.email });
};

export const handleSentry = (user: CurrentUserType | null) => {
    if (user && user.isThematicAdmin) {
        Sentry.setUser({ email: user.email, id: user.id });
    } else if (user) {
        Sentry.setUser({ id: user.id });
    } else {
        Sentry.setUser(null);
    }
};
